import React from "react";
import { Home, Services, Contactus, About, Team } from "./Pages/index";
import Layout from "./Hoc/Layout/Laout";
import { Routes, Route, useLocation } from "react-router-dom";
import { useTransition, animated } from "react-spring";

// TEMP
import { BottomNav } from "./Components/UI/index";

function App() {
  const location = useLocation();

  const transitions = useTransition(location, {
    from: { opacity: 0, transform: "translate(100%, 0)" },
    enter: { opacity: 1, transform: "translate(0%, 0)" },
    leave: { opacity: 0, transform: "translate(-50%, 0)" },
  });

  return (
    <Layout>
      {transitions((props, item, key) => (
        <animated.div key={key} style={props}>
          <Routes location={item}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/aboutus" element={<About />} />
            <Route path="/contactus" element={<Contactus />} />
            <Route path="/team" element={<Team />} />
          </Routes>
        </animated.div>
      ))}
      <BottomNav />
    </Layout>
  );
}

export default App;
